import { useState } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { RequireCapability } from "@/components/require-capability";
import { Checkbox } from "@/components/ui/checkbox";
import { SterilizationPresetsTable } from "@/features/inventory/sterilization-presets-table";
import { SterilizationAdditivesTable } from "@/features/inventory/sterilization-additives-table";

export const Route = createFileRoute("/settings/inventory/sterilization")({
  component: () => (
    <RequireCapability cap="inventory:manage">
      <SettingsSterilizationPage />
    </RequireCapability>
  ),
});

function SettingsSterilizationPage() {
  const [includeArchived, setIncludeArchived] = useState(false);

  return (
    <div className="container mx-auto px-4 py-6 flex flex-col grow min-h-0 gap-6 overflow-y-auto">
      <div className="flex items-start justify-between gap-4">
        <div>
          <h1 className="text-lg font-semibold">Sterilization</h1>
          <p className="text-sm text-muted-foreground">
            Presets pre-fill a sterilization cycle and its additives; common
            additives are the doses offered when sterilizing.
          </p>
        </div>
        <label className="flex items-center gap-1.5 text-sm text-olive-11">
          <Checkbox
            checked={includeArchived}
            onCheckedChange={(v) => setIncludeArchived(v === true)}
          />
          Show archived
        </label>
      </div>

      <section className="flex flex-col gap-2">
        <h2 className="text-base font-medium">Presets</h2>
        <SterilizationPresetsTable includeArchived={includeArchived} />
      </section>

      <section className="flex flex-col gap-2">
        <h2 className="text-base font-medium">Common additives</h2>
        <SterilizationAdditivesTable includeArchived={includeArchived} />
      </section>
    </div>
  );
}
